import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PeopleGroupOMIcon } from '@omnea-app/icons'
import { MANAGE_RECORD_ACCESS } from '../recordRules'
import { useIsPermitted } from '../useIsPermitted'
import { ManageRecordAccessDialog } from './ManageRecordAccessDialog'
import type { PermissionSetEntity } from '@omnea-digital/authz-model'

type Props = {
  entity: PermissionSetEntity
  recordId: string
  /** Absent where the page renders before the record's detail arrives. */
  recordName?: string
  onClose?: () => void
}

export const ManageRecordAccessMenuItem = ({ entity, recordId, recordName, onClose }: Props) => {
  const { t } = useTranslation('settings', { keyPrefix: 'record-access' })
  const canManagePermissions = useIsPermitted(MANAGE_RECORD_ACCESS)
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  if (!canManagePermissions) return null

  const closeDialog = () => {
    setIsDialogOpen(false)
    onClose?.()
  }

  return (
    <>
      <MenuItem onClick={() => setIsDialogOpen(true)} data-testid={`manage-${entity}-access-menu-item`}>
        <ListItemIcon>
          <PeopleGroupOMIcon />
        </ListItemIcon>
        <ListItemText>{t('menu-item')}</ListItemText>
      </MenuItem>
      <ManageRecordAccessDialog
        entity={entity}
        recordId={recordId}
        recordName={recordName}
        open={isDialogOpen}
        onClose={closeDialog}
      />
    </>
  )
}
